var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prize"},[_c('div',[(_vm.isShowSelect)?_c('PrizeSelect'):_vm._e(),(_vm.isShowDetail)?_c('PrizeDetail',{attrs:{"prizeUserCode":_vm.prizeUserCode}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }